import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";

import Dashboardworkflows from "Pages/AdminInterface/dashboard/Dashboardworkflows";

export function Dashboard() {
  return (
    <Box component="main" sx={{ pt: 8 }}>
      <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
        <Grid item xs={12} md={12}>
          <Dashboardworkflows />
        </Grid>
      </Grid>
    </Box>
  );
}
